// FETCH COMMERCIAL PRODUCTS V2
export const FETCH_COMMERCIAL_PRODUCTS_V2_REQUEST = 'FETCH_COMMERCIAL_PRODUCTS_V2_REQUEST';
export const FETCH_COMMERCIAL_PRODUCTS_V2_SUCCESS = 'FETCH_COMMERCIAL_PRODUCTS_V2_SUCCESS';
export const FETCH_COMMERCIAL_PRODUCTS_V2_FAIL = 'FETCH_COMMERCIAL_PRODUCTS_V2_FAIL';
// FETCH COMMERCIAL PRODUCTS
export const FETCH_COMMERCIAL_PRODUCT_REQUEST = 'FETCH_COMMERCIAL_PRODUCT_REQUEST';
export const FETCH_COMMERCIAL_PRODUCT_SUCCESS = 'FETCH_COMMERCIAL_PRODUCT_SUCCESS';
export const FETCH_COMMERCIAL_PRODUCT_FAIL = 'FETCH_COMMERCIAL_PRODUCT_FAIL';
